import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { reduxForm, Form } from 'redux-form';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';


import CommonFields from '../../CommonFields/CommonFields';

import Link from '../../Link';
import submit from './submit';
import validate from './validate';
import { dob } from '../../../helpers/EditProfileInfo/dobHelpers';
import { GoBackArrow } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cs from '../../../components/commonStyle.css';
import s from './EditProfileInfo.css';
import messages from '../../../locale/jsonMessages';


class EditProfileInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            countryCode: 'US',
            country: '+1'
        }
    }

    componentWillMount() {
        const { change, initialValues } = this.props;
        const { countryCode, country } = this.state;
        let day, month, year;
        if (initialValues && initialValues?.dateOfBirth) {
            const dateOfBirth = initialValues?.dateOfBirth;
            let dateOfBirthArray = dateOfBirth.split("-");
            month = Number(dateOfBirthArray[0] - 1)
            year = dateOfBirthArray[1]
            day = dateOfBirthArray[2];
        }
        let days = dob(day);
        let months = dob(month);

        change('day', days);
        change('month', months);
        change('year', year);
        change('email', initialValues?.profileBanStatus?.email);
        change('countryCode', countryCode);
        change('dialCode', country);
    }

    render() {

        const { handleSubmit, initialValues } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div className={s.sectionContainer}>
                <div className={cx('singleBtnFlexEnd', cs.spaceBottom4)}>
                    <Link to={"/siteadmin/users"} className='goBackLink'>
                        <GoBackArrow />
                        <FormattedMessage  {...messages.goBack} />
                    </Link>
                </div>
                <div className={s.sectionWrapper}>
                    <h1 className='siteAdminHeading'>{formatMessage(messages.editUserInfo)}</h1>
                    <Form onSubmit={handleSubmit(submit)}>
                        <CommonFields initialValues={initialValues} />
                    </Form>
                </div>
            </div>
        )
    }
}
EditProfileInfo = reduxForm({
    form: 'EditProfileInfo',
    validate
})(EditProfileInfo);

export default compose(injectIntl, withStyles(cs, s))(EditProfileInfo);